import {ENDPOINTS} from '../common/endpoints';
import {GuidLightDto} from '../models/common/IGuidLight';
import {ProductTypeForOrderGuidDto} from '@mybake/ui/models/Order/IOrderGuid';
import {ProductTypeGuidDto, SaveProductTypeGuidRequest} from '../models/ProductTypes/IProductTypeGuid';
import {baseAPI} from './BaseAPI';
import {TAGS} from './TagTypes';

const relatedTags = [
    TAGS.PRODUCT_TYPE,
    TAGS.RECIPES,
    TAGS.RECIPES_LIGHT,
    TAGS.RECIPES_FOR_ORDER,
    TAGS.PACKAGES,
    TAGS.PACKAGES_LIGHT,
    TAGS.PACKAGES_FOR_ORDERS,
];

export const productTypesAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getProductTypesV2: build.query<ProductTypeGuidDto[], void>({
            query: () => ({url: ENDPOINTS.PRODUCT_TYPES.V2, method: 'GET'}),
            providesTags: (result) => result?.map(({id}) => ({type: TAGS.PRODUCT_TYPE, id})) ?? [TAGS.PRODUCT_TYPE],
        }),
        getProductTypesV2AllLight: build.query<GuidLightDto[], void>({
            query: () => ({url: ENDPOINTS.PRODUCT_TYPES.V2_ALL_LIGHT, method: 'GET'}),
            providesTags: [TAGS.PRODUCT_TYPE],
        }),
        getProductTypesForOrderV2: build.query<ProductTypeForOrderGuidDto[], void>({
            query: () => ({url: ENDPOINTS.PRODUCT_TYPES.V2_FOR_ORDER, method: 'GET'}),
            providesTags: [TAGS.PRODUCT_TYPE],
        }),
        getProductTypeV2: build.query<ProductTypeGuidDto, string>({
            query: id => ({url: `${ENDPOINTS.PRODUCT_TYPES.V2}/${id}`, method: 'GET'}),
            providesTags: (_result, _error, id) => [{type: TAGS.PRODUCT_TYPE, id}],
        }),
        createProductTypeV2: build.mutation<ProductTypeGuidDto, SaveProductTypeGuidRequest>({
            query: body => ({url: ENDPOINTS.PRODUCT_TYPES.V2, method: 'POST', body}),
            invalidatesTags: relatedTags,
        }),
        updateProductTypeV2: build.mutation<ProductTypeGuidDto, {id: string; body: SaveProductTypeGuidRequest}>({
            query: ({id, body}) => ({url: `${ENDPOINTS.PRODUCT_TYPES.V2}/${id}`, method: 'PUT', body}),
            invalidatesTags: (_result, _error, {id}) => [...relatedTags, {type: TAGS.PRODUCT_TYPE, id}],
        }),
        deleteProductTypeV2: build.mutation<void, string>({
            query: id => ({url: `${ENDPOINTS.PRODUCT_TYPES.V2}/${id}`, method: 'DELETE'}),
            invalidatesTags: relatedTags,
        }),
    }),
});
